import { observer } from 'mobx-react-lite';

import { locales } from 'constants/common';
import { useStore } from 'hooks/useStore';

import css from './AsideMedia.module.css';

const AsideMedia = () => {
  const {
    app: { env, locale },
  } = useStore();

  return (
    <div className={css.container}>
      <div className={css.media}>
        {locale === locales.ru && <span ati-userdata-info="doc-preset=loads_right_scroll;doc-extra-content=lastNews" />}

        {env && (
          <iframe
            height={400}
            src={`//news.ati.${env}/external/last-news/?count=5&with_time=1`}
            title="News"
            width={300}
          ></iframe>
        )}
      </div>
    </div>
  );
};

const connected = observer(AsideMedia);

export { connected as AsideMedia };
